import * as React from "react"
import { FC } from "react"

import * as styles from "./styles.module.scss"
import Contacts from "../Contacts"

const Header: FC = () => {
  return (
    <div className={styles.faqHeader}>
      <div className={styles.pagePadding}>
        <div className={styles.header}>
          <h1 className={styles.heading}>We’re here to help</h1>
          <p className={styles.subhead}>
            We’re available 7 days a week, 9 am – 9 pm ET
          </p>
        </div>
        <div className={styles.contacts}>
          <Contacts />
        </div>
      </div>
    </div>
  )
}

export default Header
